export default {
  common: {
    language: 'Idioma',
    logoAlt: 'Zhongze STEAM',
    cancel: 'Cancelar',
  },
  chatService: {
    chatNow: {
      label: 'Chatear ahora',
    },
    emailGate: {
      title: 'Se requiere correo electrónico',
      desc: 'Introduce tu correo electrónico para continuar el chat.',
      successMessage: 'Correo enviado. Puedes seguir chateando.',
    },
  },
  nav: {
    home: 'Inicio',
    products: 'Productos',
    software: 'Software',
    eduServices: 'Servicios educativos',
    support: 'Servicio y soporte',
    cooperation: 'Cooperación educativa',
    about: 'Sobre nosotros',

    // Sub-menus & Mega Menu
    learningPlatform: 'Plataforma de aprendizaje Zhongze STEAM',
    cloudPlatform: 'Plataforma en la nube Zhongze STEAM',
    laserSoftware: 'Software para equipos láser',
    makerK12: 'Maker educativo - Primaria y Secundaria',
    archVocational: 'Modelos arquitectónicos - Formación profesional',
    cultHigherVoc: 'Diseño cultural y creativo - FP superior',
    artsUni: 'Artes y artesanías - Universidades',
    afterSales: 'Servicio posventa',
    faq: 'Preguntas frecuentes',
    download: 'Centro de descargas',
    companyIntro: 'Perfil de la empresa',
    news: 'Noticias',
    contact: 'Contáctanos',
    device: 'Equipos',
    kits: 'Kits',
    softwareService: 'Servicios de software',
    accessories: 'Accesorios',
    forMakers: 'For Makers',
    forEducation: 'For Education',
    kitsSystem: 'Sistema de kits',
    kitsAccessories: 'Accesorios para kits',
    courses: 'Cursos',
  },
  aboutPage: {
    seoTitle: 'Sobre nosotros - Zhongze STEAM',
    banner: {
      title: 'Sobre nosotros',
    },
    about: {
      title: 'Sobre nosotros',
      body: 'Zhongze Education se fundó en 2015. Gracias a una estrecha cooperación con Hong Kong Unicom International, hemos desarrollado de forma independiente un sistema de educación maker adaptado a los niños en China, tomando como base los cursos STEAM de Europa y Estados Unidos. A través del aprendizaje socializado y la práctica, ayudamos a los niños a superar límites y crear logros extraordinarios. Con “Educación STEAM + espacio maker” como núcleo y con la misión de “formar a los creadores del futuro”, nos centramos en la educación de creatividad tecnológica para niños y adolescentes de 3 a 16 años: establecemos espacios de innovación educativa, desarrollamos productos y cursos propios, y construimos un ecosistema único de I+D de contenidos y un circuito cerrado de productos alrededor de módulos como software de diseño, grabado láser y programación. Queremos que los niños adquieran competencias clave para el futuro en proyectos reales. Nuestra visión es ser impulsores internacionales de la educación de innovación: ofrecemos no solo cursos y entornos maker, sino una nueva forma de aprender. Creemos que cada niño es un innovador del futuro: que piensen y exploren como científicos, practiquen como ingenieros, creen como diseñadores y aprendan a fabricar como makers, para descubrirse en la exploración y alcanzar su futuro en la práctica.',
    },
    intro: {
      title: '¿Por qué elegirnos?',
      desc: 'Impulsamos la educación de innovación a nivel internacional: ofrecemos cursos, entornos maker y una nueva forma de aprender. Creemos que cada niño es un innovador del futuro; que se descubra en la exploración y construya su futuro con la práctica.',
      features: {
        projectLearning:
          'Aprendizaje basado en proyectos: mediante PBL, los niños adquieren competencias clave para el futuro en proyectos reales.',
        interactiveExperiments:
          'Experimentos interactivos: a través de estas experiencias, los niños no solo dominan principios científicos básicos, sino que también desarrollan la capacidad de resolver problemas, la creatividad y el trabajo en equipo.',
      },
    },
    images: {
      aboutAlt: 'Sobre Zhongze STEAM',
      featureIcon1Alt: 'Icono de aprendizaje basado en proyectos',
      featureIcon2Alt: 'Icono de experimentos interactivos',
      introAlt: 'Por qué elegirnos',
    },
  },
  newsPage: {
    banner: {
      title: 'Noticias',
    },
    tabs: [
      { id: 'all', name: 'Todo' },
      { id: 'company', name: 'Noticias de la empresa' },
      { id: 'exhibition', name: 'Noticias de exposiciones' },
      { id: 'industry', name: 'Tendencias del sector' },
    ],
    items: [
      {
        title:
          'Henghao Laser brilla en BETT UK 2025: la tecnología láser impulsa la innovación educativa',
      },
      {
        title:
          'El núcleo de la innovación educativa K12: cómo las cortadoras láser CO2 impulsan la enseñanza STEAM',
      },
      {
        title:
          'Clientes de Henghao Laser brillan con Light 530 en didacta Italia 2025',
      },
      {
        title: 'Zhongze STEAM lanza una nueva solución educativa inteligente',
      },
      {
        title:
          'Tendencias de la educación del futuro: integración profunda de la IA y la educación maker',
      },
    ],
  },
  newsInformationPage: {
    banner: {
      title: 'Noticias',
    },
    tabs: [
      { id: 'all', name: 'Todo' },
      { id: 'company', name: 'Noticias de la empresa' },
      { id: 'exhibition', name: 'Noticias de exposiciones' },
      { id: 'industry', name: 'Tendencias del sector' },
    ],
    items: [
      {
        title:
          'Zhongze Technology presenta una nueva generación de kits de robótica educativa y lidera la nueva tendencia de la educación STEM',
      },
      {
        title:
          'La IA llega a las escuelas: cómo potenciar el pensamiento lógico del alumnado mediante la enseñanza de programación',
      },
      {
        title:
          'El Concurso Nacional de Robótica Juvenil 2023 concluye con éxito; el equipo apoyado por Zhongze logra excelentes resultados',
      },
      {
        title:
          'Explorar la educación del futuro: propuesta de aulas inteligentes en el contexto de la transformación digital',
      },
      {
        title:
          'Zhongze Technology alcanza cooperación estratégica con varias universidades y cofundan un laboratorio conjunto de IA',
      },
    ],
  },

  home: {
    banner: {
      item1: {
        title: 'Educación maker',
        desc: 'Ofrece un espacio para experimentar y explorar, impulsando el desarrollo integral del alumnado',
      },
      item2: {
        title: 'Abrir la puerta a la inteligencia',
        desc: 'Desde el uso de equipos láser hasta el aprendizaje con kits y cursos, cubre de forma integral distintas necesidades de aprendizaje.',
      },
      item3: {
        title: 'Kits y cursos',
        desc: 'IA + educación ISTEAM | educación de innovación: cursos imprescindibles para mejorar la eficacia',
      },
    },
    resources: {
      title: 'Recursos didácticos STEM completos',
      tabs: {
        laser: {
          name: 'Cortadora láser',
          title: 'Equipos láser',
          desc1: 'Cortadora y grabadora láser inteligente de escritorio',
          desc2:
            'Corte de alta precisión│Operación inteligente y sencilla│Procesamiento eficiente│Seguro y ecológico',
        },
        software: {
          name: 'Software',
          title: 'Software educativo',
          desc1: 'Software integral y multidimensional',
          desc2:
            'Plataforma en la nube | Plataforma de aprendizaje | Light Maker',
        },
        ai: {
          name: 'Asistencia didáctica inteligente con IA',
          title: 'Asistencia didáctica inteligente',
          desc1: 'Monitorización en tiempo real y alertas del equipo',
          desc2: 'Asistente docente con IA | Panel visual',
        },
        kits: {
          name: 'Kits y cursos',
          title: 'Kits de cursos completos',
          desc1: 'Aprendizaje PBL basado en proyectos',
          desc2: 'Material didáctico complementario | Práctica manual',
        },
      },
    },
    different: {
      title: 'Lo que nos diferencia',
      items: {
        solution: {
          title: 'Solución educativa de IA',
          desc: 'Mejora los resultados de enseñanza y la experiencia de aprendizaje',
        },
        course: {
          title: 'Curso de pensamiento creativo',
          desc: 'Cursos adecuados para niños y adolescentes de 3 a 16 años',
        },
        product: {
          title: 'Productos educativos de innovación',
          desc: 'Creación láser con un clic',
        },
        space: {
          title: 'Espacio de exploración maker',
          desc: 'Combinación de innovación y practicidad',
        },
      },
    },
    creative: {
      title: 'La creatividad impulsa, crear da forma al futuro',
      machineDesc:
        'Máquina láser inteligente de escritorio para cortar y grabar',
      lightBlue530Desc: 'Máquina inteligente de corte y grabado láser azul',
      markM20Desc: 'Máquina de marcado láser de alta precisión',
      light640Desc: 'Máquina profesional de corte y grabado láser de sobremesa',
    },
    innovation: {
      title: '¿Cómo fomentar el aprendizaje innovador?',
      desc: 'Zhongze STEAM se dedica al desarrollo de productos educativos de innovación de alta calidad, incluidas cortadoras láser. Estos productos ayudan al alumnado a realizar aprendizaje práctico en ciencia, tecnología, ingeniería, arte y matemáticas.',
      items: {
        steam: 'STEAM',
        coding: 'Programación',
        light530: 'Usar Light 530',
        robotics: 'Tecnología robótica',
      },
    },
    bottomBanner: {
      title: 'Llevar la educación con IA a la práctica',
      subtitle:
        'IA+educación: impulso digital e integración de ideas innovadoras',
      desc: 'Centrados en productos láser personalizados y servicios tecnológicos, ayudamos a centros educativos y empresas a integrar【IA+educación】',
    },
  },
  software: {
    laserSoftware: {
      bannerTitle: 'Software para equipos láser  Light Maker',
      bannerDesc:
        'Software profesional para equipos láser: sencillo y eficiente, centrado en la experiencia de corte y grabado.',
      bannerImageAlt: 'Interfaz de Light Maker',
      creationTitle: 'Hacer que crear sea sencillo',
      features: {
        proDesignTool: 'Herramientas de diseño profesionales',
        highPrecisionParams: 'Ajustes de parámetros de alta precisión',
        multiDeviceControl: 'Gestión y control de múltiples dispositivos',
        assetLibrary: 'Potente sistema de gestión de recursos',
      },
      intro: {
        imageAlt: 'Demostración de funciones',
        items: {
          item1: {
            title: 'Sistema de diseño potente y fácil de usar',
            desc: 'Software de creación potente, compatible con diseños de alta calidad en formatos JPG, DXF, AI, DST, PNG, BMP, TIF y SVG.',
          },
          item2: {
            title: 'Profesionalidad',
            desc: 'Funciones profesionales de dibujo que cubren todas las necesidades de creación. Tanto diseños complejos como cortes sencillos se resuelven con facilidad.',
          },
        },
      },
      downloadTitle: 'Descargar software',
      downloadButton: 'Descargar y probar',
      downloadApps: {
        lightMakerApp: 'LightMaker App',
        laserMakerLightSystem: 'LaserMaker Light System',
      },
    },
    learningPlatform: {
      bannerTitle: 'Plataforma de aprendizaje Zhongze STEAM',
      bannerDescLine1:
        'La plataforma de aprendizaje Zhongze STEAM es una herramienta de aprendizaje en línea innovadora, diseñada para ofrecer a estudiantes y docentes una solución integral de software educativo.',
      bannerDescLine2:
        'Tanto en dispositivos móviles como en ordenadores, los usuarios pueden acceder y utilizar nuestra plataforma fácilmente.',
      bannerImageAlt: 'Interfaz de la plataforma de aprendizaje Zhongze STEAM',
      exploreTitle: 'Explora posibilidades infinitas, crea un futuro brillante',
      exploreTabs: [
        { name: 'Crear' },
        { name: 'Guía para principiantes' },
        { name: 'Aprendizaje de modelado' },
        { name: 'Crear con un clic' },
        { name: 'Generación de imágenes con IA' },
      ],
      tabContentAlt: 'Demostración de funciones',
      introTitle: 'Plataforma de aprendizaje innovadora',
      introItems: [
        {
          title: 'Nueva experiencia de aprendizaje eficiente',
          desc: 'La plataforma de aprendizaje Zhongze STEAM integra en un solo lugar el aprendizaje de cursos, el diseño gráfico y el corte láser. La interfaz tipo tarjetas es clara e intuitiva, y la operación es fluida; conecta sin fricciones el diseño creativo con la fabricación física, para empezar rápido y con eficiencia.',
        },
        {
          title: 'Inteligente y cómodo, ideal para principiantes',
          desc: 'Incluye una amplia biblioteca de imágenes y preajustes inteligentes de parámetros: crea con un clic y empieza en segundos. Los tutoriales detallados en el móvil reducen la barrera de entrada, y la supervisión en la nube en tiempo real protege la seguridad en todo el proceso de enseñanza.',
        },
      ],
      introImageAlt: 'Plataforma de aprendizaje innovadora',
      galleryAlt: 'Demostración de la plataforma',
      downloadTitle: 'Descargar software',
      downloadApps: [
        { name: 'App de la plataforma Zhongze STEAM' },
        { name: 'Software de diseño Zhongze para PC' },
      ],
      downloadButtonText: 'Descargar y probar',
    },
    cloudPlatform: {
      bannerTitle: 'Plataforma en la nube Zhongze STEAM',
      bannerDesc:
        'Herramienta integral de gestión educativa que admite envío y recepción de tareas, supervisión de equipos, solicitudes de reparación y configuración de parámetros, ayudando a docentes, estudiantes y centros a gestionar con eficiencia.',
      bannerImageAlt: 'Interfaz de la plataforma en la nube Zhongze STEAM',
      exploreTitle: 'Simplificar la gestión docente',
      exploreTabs: [
        { name: 'Crear' },
        { name: 'Guía para principiantes' },
        { name: 'Aprendizaje avanzado' },
      ],
      tabContentAlt: 'Demostración de funciones',
      introTitle: 'Mejorar la eficiencia educativa',
      introItems: [
        {
          title: 'Operación cómoda',
          desc: 'Creación con un clic: biblioteca integrada y configuración de parámetros para simplificar el flujo. Supervisión de equipos: monitorización en tiempo real del estado para garantizar el buen desarrollo de las actividades docentes.',
        },
        {
          title: 'Gestión unificada',
          desc: 'Conexión de equipos en paralelo: admite la conexión de otros equipos del aula maker y permite gestionarlos con un clic, mejorando la eficiencia de administración.',
        },
        {
          title: 'Supervisión en tiempo real',
          desc: 'Estado del equipo: conocer en tiempo real el funcionamiento y solicitar reparación a tiempo ante fallos. Mantenimiento: el sistema recuerda periódicamente el mantenimiento según el tiempo de uso y la frecuencia, prolongando la vida útil y mejorando la calidad de corte.',
        },
      ],
      introImageAlt: 'Plataforma de aprendizaje innovadora',
      galleryTitle: 'Llevar la educación con IA a la práctica',
      galleryDesc:
        'IA+educación: impulso digital e integración de ideas innovadoras',
    },
  },
  eduServices: {
    banner: {
      title: 'IA+educación',
      desc: 'La solución de enseñanza digital e inteligente de Zhongze Education ayuda a formar talento innovador. Orientada al desarrollo educativo y a las necesidades del alumnado, ofrece soluciones de educación con IA para todas las etapas en centros K-12.',
      imageAlt: 'Banner de la solución educativa',
    },
    recommended: {
      title: 'Productos recomendados',
      products: [
        { name: 'Light 640', alt: 'Light 640' },
        { name: 'Light 530', alt: 'Light 530' },
        { name: 'Mark M20', alt: 'Mark M20' },
        { name: 'Light Blue 530', alt: 'Light Blue 530' },
      ],
    },
    solutionCategories: {
      title: 'Crear un espacio docente integral',
      tabs: {
        'teaching-assist': 'Asistencia didáctica inteligente',
        'process-optimize': 'Optimización del proceso docente',
        'device-manage': 'Gestión de equipos',
      },
      tabContents: {
        'teaching-assist': {
          title: 'Asistencia didáctica inteligente',
          features: [
            '·Supervisión en tiempo real y recursos del equipo',
            '·Asistente de aprendizaje inteligente con IA',
            '·Panel visual',
          ],
        },
        'process-optimize': {
          title: 'Optimización del proceso docente',
          features: [
            '·Asignación y corrección de tareas en línea',
            '·Control centralizado remoto de recursos en la nube del curso',
          ],
        },
        'device-manage': {
          title: 'Gestión de equipos',
          features: [
            '·Supervisión en tiempo real de equipos educativos',
            '·Solicitud remota de reparación de equipos',
          ],
        },
      },
      categories: [
        {
          title: 'Asignar y corregir tareas en línea',
          description:
            'Sistema inteligente de gestión de tareas que mejora la eficiencia docente',
        },
        {
          title: 'Solicitud remota de reparación de equipos',
          description:
            'Servicio cómodo de mantenimiento y reparación remotos de equipos',
        },
        {
          title: 'Control centralizado remoto, simplificar el proceso docente',
          description:
            'Plataforma unificada de gestión remota para optimizar el flujo docente',
        },
        {
          title: 'Recursos en la nube del curso',
          description:
            'Recursos de cursos y materiales didácticos abundantes en la nube',
        },
        {
          title: 'Supervisión en tiempo real de equipos educativos',
          description:
            'Supervisar el estado del equipo en tiempo real para garantizar el desarrollo de la enseñanza',
        },
        {
          title: 'Asistente docente inteligente con IA',
          description: 'Sistema de apoyo docente inteligente impulsado por IA',
        },
      ],
      solutionCards: [
        { title: 'Solución digital e inteligente para innovación' },
        { title: 'Solución de aula inteligente para Primaria y Secundaria' },
        { title: 'Solución de habilidades para FP media y superior' },
        { title: 'Solución de aula de IA para universidades' },
      ],
    },
    solutions: {
      title: 'Solución educativa integral',
      items: [
        {
          title: 'Equipos',
          description:
            'En el contexto de la educación impulsada por IA, las cortadoras láser Henghao, con soporte de una plataforma inteligente en la nube, se integran profundamente con la plataforma de enseñanza láser en la nube de Zhongze STEAM. El profesorado puede gestionar equipos a distancia, asignar tareas y seguir el progreso del alumnado. Esta integración no solo mejora la eficiencia docente, sino que también ofrece una experiencia de aprendizaje más personalizada.',
          buttonText: 'Ver detalles →',
        },
        {
          title: 'Software',
          description:
            'La plataforma educativa Zhongze integra tecnologías de IA para ofrecer aprendizaje personalizado, herramientas inteligentes, experiencias interactivas y recursos en la nube. Admite gestión de cursos y tareas, supervisión y alertas de equipos, y análisis de datos. En combinación con la plataforma de aprendizaje Zhongze (APP/PC) y la herramienta Light Maker, apoya la enseñanza de forma integral, optimiza recursos e impulsa la innovación educativa, proporcionando un fuerte respaldo a docentes, estudiantes e instituciones.',
          buttonText: 'Ver detalles →',
        },
        {
          title: 'Cursos',
          description:
            'Los cursos de corte e innovación de Zhongze Education son sistemáticos y modulares, diseñados para jóvenes, y buscan despertar interés y potenciar capacidades. Incluyen conocimientos tecnológicos, pensamiento innovador, práctica por proyectos y experimentos científicos, ayudando a formar talento de innovación para el futuro e impulsar el desarrollo social.',
          buttonText: 'Ver detalles →',
        },
      ],
    },
    managementPlatform: {
      title: 'Plataforma de gestión docente inteligente de Zhongze Education',
      desc: 'Ofrece rutas de aprendizaje personalizadas, herramientas docentes inteligentes, experiencias interactivas y una biblioteca de recursos en la nube. Admite gestión de cursos, seguimiento del progreso del alumnado, tareas en línea, supervisión y alertas en tiempo real del equipamiento docente, análisis de datos, etc. Al integrar tecnologías de IA, mejora los resultados de enseñanza y optimiza la asignación de recursos educativos, proporcionando apoyo integral a estudiantes, docentes, escuelas e instituciones para impulsar conjuntamente el desarrollo y la innovación educativa.',
      items: [
        {
          title: 'Solución digital e inteligente para innovación',
          alt: 'Solución digital e inteligente para innovación',
        },
        {
          title: 'Solución de aula inteligente para Primaria y Secundaria',
          alt: 'Solución de aula inteligente para Primaria y Secundaria',
        },
        {
          title: 'Solución de habilidades para FP media y superior',
          alt: 'Solución de habilidades para FP media y superior',
        },
        {
          title: 'Solución de aula de IA para universidades',
          alt: 'Solución de aula de IA para universidades',
        },
      ],
      action: {
        text: 'Obtener una solución personalizada',
        alt: 'Icono de contáctanos',
      },
    },
  },
  makerK12: {
    banner: {
      title: 'Maker educativo—Primaria y Secundaria',
    },
    intro: {
      title: 'Cortadoras láser en educación y escuelas',
      desc: 'Usar cortadoras láser en la escuela es seguro, sin contacto y digital, desde la idea hasta el producto final. Permite materializar fácilmente las ideas creativas del alumnado.',
      imageAlt: 'Cortadora láser en la fabricación de modelos arquitectónicos',
    },
    scenesFeatured: {
      title:
        'Transformar la forma de aprender con herramientas educativas de vanguardia',
      desc: 'Ofrecemos tecnología líder del sector para aumentar la creatividad, el pensamiento crítico y las habilidades técnicas del alumnado.',
    },
    scenes: {
      items: [
        {
          title: 'Una plataforma de creación láser para cada estudiante',
          desc: 'Poner en práctica la metodología y fortalecer la participación del alumnado, para que pueda desarrollar pensamiento creativo en clase con herramientas potentes.',
        },
        {
          title: 'Kits de electrónica y programación',
          desc: 'Con kits interactivos, el alumnado participa en programación práctica, robótica e inteligencia artificial.',
        },
        {
          title: 'Educación técnico-profesional',
          desc: 'Con una plataforma de tecnología láser, se construyen itinerarios profesionales y se desarrollan habilidades para adaptarse a un mercado laboral cambiante y crear más oportunidades.',
        },
      ],
    },
    solutions: {
      title:
        'Los modelos arquitectónicos se aplican ampliamente en muchos ámbitos',
      items: [
        { title: 'Escuelas/distritos K12' },
        { title: 'Instituciones de formación' },
        { title: 'Laboratorios de investigación y cursos especializados' },
        { title: 'Espacios maker' },
        { title: 'Bibliotecas/museos de arquitectura y diseño' },
        { title: 'Cursos creativos' },
      ],
    },
    bannerLeft: {
      title: 'Llevar la educación con IA a la práctica',
      subtitle:
        'IA+educación: impulso digital e integración de ideas innovadoras',
    },
    products: {
      tabs: [
        {
          title: 'Equipos láser',
          title1: 'Herramienta de creación - cortadora láser',
          description:
            'Light 530 y 640 combinan componentes de primera calidad, procesos de fabricación de alta calidad y un estricto control de inspección. Son máquinas láser potentes, de alto rendimiento y gran estabilidad, con corte y grabado precisos, que se adaptan perfectamente a las necesidades de creación láser en escenarios de educación de innovación.',
        },
        {
          title: 'Software',
          title1: 'Experto en dibujo - LightMaker',
          description:
            'Ofrece a estudiantes seguridad, velocidad, funciones inteligentes y un diseño tecnológico altamente innovador. LightMaker es compatible con múltiples programas de diseño, incluidos AI, PS, CorelDRAW, AutoCAD, Solidworks, etc., y permite subir archivos de alta calidad en formatos JPG, DXF, AI, DST, PNG, BMP, TIF y SVG.',
        },
        {
          title: 'Cursos',
          title1: 'Enseñanza diversa - cursos de educación de innovación',
          description:
            'Sabemos que cada niño es único, por eso nuestros cursos son flexibles y diversos, y buscan despertar el interés y el potencial de cada estudiante. Los contenidos incluyen, entre otros, conocimientos tecnológicos básicos, entrenamiento de pensamiento innovador, práctica por proyectos y experimentos científicos.',
        },
      ],
    },
    learning: {
      title: '¿Cómo aplicar las cortadoras láser Zhongze STEAM en el aula?',
      teacher: {
        title: 'Docentes',
        lines: [
          'Crear material didáctico y anexos para el curso',
          'Las cortadoras láser ayudan al profesorado a producir materiales y accesorios de aula con alta eficiencia, y también permiten desarrollar métodos de enseñanza más innovadores.',
        ],
      },
      student: {
        title: 'Estudiantes',
        lines: [
          'Desarrollar habilidades prácticas',
          'En clase, las cortadoras láser acompañan al alumnado en aprendizajes interdisciplinares como diseño, ingeniería y tecnología, ayudándoles a materializar sus ideas.',
        ],
      },
    },
    carousel: {
      items: [
        { alt: 'Escena de fabricación de modelos arquitectónicos 1' },
        { alt: 'Escena de fabricación de modelos arquitectónicos 2' },
        { alt: 'Escena de fabricación de modelos arquitectónicos 3' },
      ],
    },
  },
  archVocational: {
    banner: {
      title: 'Modelos arquitectónicos - Formación profesional',
    },
    intro: {
      title:
        '¿Cómo se usan las cortadoras láser en la fabricación de modelos arquitectónicos?',
      desc: 'Puede utilizar el corte y grabado láser para fabricar modelos arquitectónicos y las piezas más pequeñas en la industria de maquetas y juguetes. Permite cortar con rapidez y precisión textiles, plásticos, madera, tableros chapados, MDF, PMMA, cartón, papel, espuma, poliestireno, láminas, acrílico, etc.',
      imageAlt: 'Cortadora láser en la fabricación de modelos arquitectónicos',
    },
    scenesFeatured: {
      title:
        'La fuerza innovadora en la fabricación de modelos arquitectónicos',
      desc: 'Le ayudamos a crear maquetas finas y modelos arquitectónicos de alta calidad, presentando su plano creativo con detalle.',
    },
    scenes: {
      items: [
        {
          title: 'Alta precisión',
          desc: 'Las cortadoras láser pueden cortar materiales con altísima precisión; el margen de error se controla a un nivel muy bajo, garantizando que cada pieza del modelo arquitectónico tenga dimensiones exactas y se ajuste perfectamente a los planos de diseño.',
        },
        {
          title: 'Materiales diversos',
          desc: 'La textura natural de la madera, la transparencia y brillo del acrílico, y la ligereza y plasticidad del papel pueden mostrar su encanto único mediante el corte y grabado láser.',
        },
        {
          title: 'Gran capacidad para formas complejas',
          desc: 'Para geometrías complejas y detalles finos habituales en modelos arquitectónicos, el corte láser lo hace fácilmente, como curvas y estructuras irregulares, aportando más espacio creativo a la fabricación de maquetas.',
        },
      ],
    },
    solutions: {
      title:
        'Los modelos arquitectónicos se aplican ampliamente en muchos ámbitos',
      items: [
        { title: 'Aplicaciones educativas y de investigación académica' },
        { title: 'Fabricación de maquetas y sector del juguete' },
        { title: 'Elementos decorativos y rasgos arquitectónicos' },
        { title: 'Inmobiliaria y planificación urbana' },
        { title: 'Decoración y reformas arquitectónicas' },
      ],
    },
    bannerLeft: {
      title: 'Llevar la educación con IA a la práctica',
      subtitle:
        'IA+educación: impulso digital e integración de ideas innovadoras',
    },
    products: {
      tabs: [
        {
          title: 'Equipos adecuados',
          title1: 'Elegir el equipo adecuado',
          description:
            'Los equipos láser pueden convertir rápidamente las ideas del alumnado en objetos reales, ya sea para maquetas, diseño o creación artística. Desde manualidades sencillas hasta diseños mecánicos complejos, las cortadoras y grabadoras láser completan las tareas con precisión, permitiendo que el alumnado aprenda y crezca mediante la práctica. ',
        },
        {
          title: 'Diseño propio',
          title1: 'Diseño propio',
          description:
            'Modifique el diseño de forma intuitiva y previsualice el resultado final. Corte y replique detalles de cualquier diseño en diversos materiales: optimice su obra con texto, logotipos, imágenes o fotos. Puede decorar rápidamente sus modelos arquitectónicos.',
        },
        {
          title: 'Tu mercado',
          title1: 'Mejorar las habilidades del alumnado',
          description:
            'Marcadora láser portátil, ideal para marcar y grabar detalles en modelos arquitectónicos. Fácil de usar y de transportar, es una herramienta imprescindible para la enseñanza de arquitectura.',
        },
      ],
    },
    learning: {
      title: 'Enseñanza de cursos multidisciplinares',
      groups: [
        {
          title: 'Maquetas a escala',
          lines: [
            'Preciso y detallado, satisface las necesidades de creación a escala',
            'Presenta con finura detalles de grabado/corte láser en múltiples materiales, elimina procesos complejos, mejora la eficiencia creativa y reduce errores manuales.',
          ],
        },
        {
          title: 'Diseño de interiores',
          lines: [
            'Ajuste los detalles del diseño a la primera. Con cámara integrada, previsualice fácilmente posición y tamaño: lo que ve es lo que obtiene. Ejecute corte/grabado con eficacia y reduzca el desperdicio de material.',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: 'Escena de fabricación de modelos arquitectónicos 1' },
        { alt: 'Escena de fabricación de modelos arquitectónicos 2' },
        { alt: 'Escena de fabricación de modelos arquitectónicos 3' },
      ],
    },
  },
  artsUniversity: {
    banner: {
      title: 'Artes y artesanías - Universidades',
    },
    intro: {
      title: 'Cómo usar equipos láser para procesar arte y artesanía',
      desc: 'El equipo ofrece al alumnado una plataforma para convertir ideas creativas en objetos reales, estimulando el pensamiento innovador y la creatividad. Pueden diseñar diversos modelos y obras únicas, como recortes de papel con láser y sellos.',
      imageAlt: 'Equipo láser en el procesamiento de arte y artesanía',
    },
    scenesFeatured: {
      title: 'Desarrollo de habilidades técnicas',
      desc: 'Al operar cortadoras y grabadoras láser, el alumnado adquiere conocimientos profundos de ciencia de materiales y tecnologías de procesamiento, y mejora la destreza manual y la capacidad de resolver problemas.',
    },
    scenes: {
      items: [
        {
          title: 'Estimular el pensamiento creativo',
          desc: 'Las cortadoras y grabadoras láser permiten materializar diseños creativos del alumnado, como maquetas y obras de arte, reforzando su creatividad.',
        },
        {
          title: 'Integración multidisciplinaria',
          desc: 'El corte y grabado láser abarca conocimientos de varias disciplinas, como física, química, ciencia de materiales e informática. En la enseñanza universitaria, puede promover la integración entre disciplinas y desarrollar competencias integrales.',
        },
        {
          title: 'Proyectos de enseñanza práctica',
          desc: 'La tecnología de corte y grabado láser puede aplicarse a proyectos prácticos universitarios, como formación en ingeniería, diseño artístico y creatividad cultural. Por ejemplo, el alumnado puede fabricar modelos arquitectónicos, piezas mecánicas o esculturas, combinando teoría y práctica.',
        },
      ],
    },
    solutions: {
      title: 'Aplicaciones en la fabricación universitaria de artesanías',
      items: [
        { title: 'Productos minoristas personalizados' },
        { title: 'Personalización de regalos' },
        { title: 'Marketing festivo' },
        { title: 'Joyería y accesorios' },
        { title: 'Ropa personalizada' },
      ],
    },
    bannerLeft: {
      title: 'Llevar la educación con IA a la práctica',
      subtitle:
        'IA+educación: impulso digital e integración de ideas innovadoras',
    },
    products: {
      tabs: [
        {
          title: 'Equipos adecuados',
          title1: 'Elegir el equipo adecuado',
          description:
            'Al elegir el equipo adecuado de corte y grabado láser, las universidades pueden proporcionar herramientas prácticas avanzadas, estimular la creatividad del alumnado y mejorar la calidad y la eficiencia de la enseñanza.',
        },
        {
          title: 'Diseño propio',
          title1: 'Diseño propio',
          description:
            'Modifique el diseño de forma intuitiva y previsualice el resultado final. Grabe y replique detalles de cualquier diseño en diversos materiales: optimice su obra con texto, logotipos, imágenes o fotos. La grabadora láser es muy fácil de usar y permite decorar rápidamente sus obras.',
        },
        {
          title: 'Arte y diseño',
          title1: 'Enseñanza en especialidades de arte y diseño',
          description:
            'En carreras como diseño artístico y diseño industrial, las cortadoras y grabadoras láser se utilizan ampliamente en proyectos de cursos y trabajos de fin de grado. El alumnado puede convertir rápidamente ideas de diseño en prototipos físicos, desarrollando capacidad de creación de prototipos.',
        },
      ],
    },
    learning: {
      title: 'Llevar el láser a la escuela',
      groups: [
        {
          title: 'Preciso y eficiente, ahorra tiempo y esfuerzo',
          lines: [
            'Las cortadoras láser Zhongze admiten previsualización con cámara: alineación precisa sin desperdicio de material, incluso para principiantes.',
            'Uso fluido y sencillo: coloque el material y diseñe de forma creativa; lo que ve es lo que obtiene.',
            'Creación precisa, aproveche cada pieza de material y ahorre tiempo, esfuerzo y material.',
          ],
        },
        {
          title: 'Alta potencia, fácil para materiales diversos',
          lines: [
            'Con láser CO₂ de alta potencia: grabado y corte en un solo equipo.',
            'Corte y grabe fácilmente acrílico, madera, bambú y otros materiales, creando un flujo de trabajo amigable para aficionados a las manualidades y haciendo la creación más simple y eficiente.',
          ],
        },
      ],
    },
    carousel: {
      items: [{ alt: 'Escena de fabricación de arte y artesanía 1' }],
    },
  },
  cultHigherVoc: {
    banner: {
      title: 'Diseño cultural y creativo—FP superior',
    },
    intro: {
      title: 'Equipos láser en el diseño cultural y creativo',
      desc: 'Las especialidades de diseño cultural y creativo en centros de FP superior suelen contar con equipos avanzados de corte y grabado láser, como grabadoras láser, que cubren necesidades prácticas de enseñanza en distintas etapas.',
      imageAlt: 'Equipo láser en el diseño cultural y creativo',
    },
    scenesFeatured: {
      title: 'Abrir posibilidades infinitas de creatividad y calidad',
      desc: 'Con un rendimiento sobresaliente y una capacidad de corte precisa, se convierte en una herramienta imprescindible para diseñadores culturales y creativos.',
    },
    scenes: {
      items: [
        {
          title: 'Corte de alta precisión, detalles perfectos',
          desc: 'Para patrones complejos y formas únicas en el diseño cultural y creativo, las cortadoras láser los reproducen con fidelidad, asegurando que cada detalle se presente con precisión en el producto final.',
        },
        {
          title: 'Procesamiento de materiales diversos',
          desc: 'Los equipos láser pueden trabajar con múltiples materiales como madera, acrílico, cuero y metal, ofreciendo una amplia selección para el diseño de productos culturales y creativos.',
        },
        {
          title: 'Operación inteligente, simplifica la realización creativa',
          desc: 'El alumnado solo necesita introducir el diseño en el ordenador y la cortadora láser lo reconoce automáticamente y realiza el corte con precisión. Este modo inteligente reduce la exigencia de habilidades profesionales y mejora la estabilidad y fiabilidad del proceso.',
        },
      ],
    },
    solutions: {
      title: 'Que más buenos diseños lleguen a la vida diaria',
      items: [
        { title: 'Cuadros decorativos de temática cultural' },
        { title: 'Diseño de lámparas creativas' },
        { title: 'Adornos y accesorios para el hogar' },
        { title: 'Portalápices y cajas organizadoras de papelería' },
        { title: 'Accesorios de estilo étnico' },
        { title: 'Souvenirs turísticos' },
      ],
    },
    bannerLeft: {
      title: 'Llevar la educación con IA a la práctica',
      subtitle:
        'IA+educación: impulso digital e integración de ideas innovadoras',
    },
    learning: {
      title:
        'Herramientas de producción en el diseño cultural y creativo de FP superior',
      groups: [
        {
          title: 'Personalización',
          lines: [
            'Las cortadoras y grabadoras láser permiten personalizar fácilmente fotos, nombres o patrones especiales, satisfaciendo la demanda de regalos únicos y conmemorativos.',
            'Por ejemplo, se pueden grabar patrones o textos indicados por el consumidor en adornos de madera, accesorios de cuero y decoraciones de acrílico, haciéndolos más personalizados.',
          ],
        },
        {
          title: 'Producción de derivados culturales y creativos',
          lines: [
            'Desde souvenirs culturales de museos hasta productos derivados de cine y animación, las cortadoras y grabadoras láser hacen que los diseños complejos sean visibles y comercializables.',
            'Pueden convertir elementos como sitios emblemáticos, edificios icónicos o IP culturales en productos reales; por ejemplo, cortar una tabla de madera común en una decoración con patrón y forma únicos, o grabar una hoja de papel común en una obra de arte fina.',
          ],
        },
        {
          title: 'Creación DIY',
          lines: [
            'Los equipos láser ayudan a aficionados a las manualidades a alcanzar un nivel superior de creación DIY: desde pequeñas artesanías hasta decoraciones únicas para el hogar, todo puede realizarse rápidamente con tecnología láser.',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: 'Escenario de diseño cultural y creativo 1' },
        { alt: 'Escenario de diseño cultural y creativo 2' },
        { alt: 'Escenario de diseño cultural y creativo 3' },
      ],
    },
  },
  eduCooperation: {
    banner: {
      title: 'Cooperación educativa',
    },
    advantages: {
      title: 'Nuestras ventajas de cooperación',
      items: [
        {
          title: 'Equipo de I+D con amplia experiencia',
          desc: 'Zhongze Education cuenta con un equipo profesional formado por ingenieros y educadores STEM, que desarrolla continuamente productos innovadores alineados con altos estándares educativos y atractivos para el alumnado.',
        },
        {
          title: 'IA+educación: impulso digital e inteligente',
          desc: 'Plataforma educativa inteligente de Zhongze: aprendizaje personalizado, herramientas inteligentes y experiencias interactivas; admite gestión de cursos, seguimiento del progreso, entrega de tareas, supervisión de equipos y análisis de datos, con abundantes recursos en la nube para una enseñanza más eficiente.',
        },
        {
          title: 'Amplio sistema de kits y cursos',
          desc: 'Ofrecemos cursos desde nivel inicial hasta avanzado sobre corte láser, hogar inteligente, transporte inteligente y más, para cubrir las necesidades de distintas edades.',
        },
      ],
    },
    modes: {
      title: 'Modalidades de colaboración',
      carouselAlts: [
        'Escenario de cooperación educativa',
        'Clase de cooperación educativa',
        'Práctica de cooperación educativa',
      ],
      items: [
        {
          title: 'Adopción de cursos',
          desc: 'Las instituciones asociadas pueden incorporar directamente nuestro sistema de cursos para mejorar rápidamente la calidad docente.',
        },
        {
          title: 'Kits',
          desc: 'Los kits están diseñados para niños de 3 a 16 años; con materiales experimentales seguros y fáciles de usar, despiertan el interés por la ciencia, la tecnología, la ingeniería, el arte y las matemáticas (STEAM).',
        },
        {
          title: 'Cooperación de productos',
          desc: 'Las instituciones asociadas pueden adquirir nuestros productos educativos, como cortadoras láser, para la enseñanza y la práctica del alumnado.',
        },
        {
          title: 'I+D conjunto',
          desc: 'Damos la bienvenida a las instituciones asociadas a participar en el desarrollo de cursos y productos, para impulsar juntos la innovación educativa.',
        },
      ],
    },
    bottomBanner: {
      lines: [
        'Llevar la educación con IA a la práctica',
        'IA+educación: impulso digital e integración de ideas innovadoras',
      ],
    },
  },
  support: {
    downloadCenter: {
      bannerTitle: 'Centro de descargas',
      sectionTitle: 'Descarga de software',
      downloadButtonText: 'Descargar cliente',
      softwareList: [
        { name: 'Light maker App' },
        { name: 'Good-laser Light maker' },
        { name: 'App de la plataforma de aprendizaje Zhongze Education' },
        { name: 'Plataforma de aprendizaje Zhongze Education' },
      ],
    },
    afterSales: {
      bannerTitle: 'Servicio posventa',
      serviceTitle: 'Servicio inteligente con AR',
      serviceItems: [
        {
          title: 'Diagnóstico remoto',
          desc: 'Asistencia remota con AR: el equipo de soporte técnico consulta el estado del equipo en tiempo real, diagnostica fallos con rapidez y ofrece recomendaciones precisas de solución.',
        },
        {
          title: 'Reparación virtual',
          desc: 'Demostración operativa con AR: muestra de forma virtual los pasos de reparación, clara y fácil de entender, para que pueda dominar el método con facilidad.',
        },
        {
          title: 'Tutorial inteligente',
          desc: 'Aprendizaje interactivo con AR: consulte las guías de operación directamente en el equipo; eficiente y cómodo.',
        },
        {
          title: 'Respuesta rápida',
          desc: 'Soporte inmediato con AR: respuesta rápida, menos espera y resolución más eficiente.',
        },
      ],
      videosTitle: 'Vídeos de operación',
      playButtonText: 'Reproducir vídeo',
      videos: [
        { title: 'Demostración de desembalaje' },
        { title: 'Cómo conectar la comunicación del equipo' },
        { title: 'Tutorial de uso de Light 530' },
        { title: 'Tutorial de instalación y puesta en marcha' },
        { title: 'Operaciones básicas del software' },
        { title: 'Solución de problemas comunes' },
      ],
      manualsTitle: 'Manual de instrucciones',
      viewPdfButtonText: 'Ver archivo PDF',
      manuals: [
        { title: 'Manual de operación de Light 530' },
        { title: 'Manual de operación de Light 640' },
        { title: 'Manual de usuario de Blue 530' },
        { title: 'Guía de mantenimiento de M20' },
        { title: 'Manual de seguridad para corte láser' },
      ],
    },
  },

  product: {
    kits: {
      bannerTitle: 'Tres grandes series de kits',
      bannerDesc:
        'Los kits permiten un aprendizaje personalizado, se adaptan a distintas edades y necesidades, y ofrecen al profesorado abundantes recursos y herramientas didácticas para enseñar y guiar con mayor eficacia.',
      sections: {
        educationTitle: 'Kits educativos',
        educationDesc: 'Fomentar pensamiento innovador y creatividad',
        creativityTitle: 'La creatividad impulsa, crear da forma al futuro',
        projectsTitle: 'Proyectos educativos diversos',
      },
      kitsTabs: [
        {
          name: 'Kit de iniciación al corte láser',
          title:
            'Kit de iniciación al corte láser\n(Tablero de madera consumible incluido)',
          desc: 'Curso STEAM de corte láser: diseñado a partir de la teoría de las inteligencias múltiples, el enfoque STEAM y el aprendizaje basado en proyectos; orientado a distintas edades, desarrolla capacidad de innovación, pensamiento crítico, resolución de problemas y habilidades de comunicación y trabajo en equipo. ',
        },
        {
          name: 'Caja mágica de ciencia',
          title:
            'Caja mágica de ciencia\n(Tablero de madera + kit de microcircuitos)',
          desc: 'El curso se ajusta a las Normas del currículo de Ciencias de la educación obligatoria (edición 2022) y desarrolla competencias clave desde cuatro dimensiones: conceptos científicos, pensamiento científico, práctica de investigación y actitud/responsabilidad. Cada clase culmina con una creación científica e incluye conceptos clave de técnicas tradicionales, ingeniería tecnológica y sociedad; guía al alumnado a pensar como científicos, mejora la capacidad de indagación y construye pensamiento científico.',
        },
        {
          name: 'Kit de programación de inteligencia artificial',
          title: 'Kit de programación de inteligencia artificial',
          desc: 'Explora la tecnología del futuro empezando por el kit de programación de IA. Los kits de granja inteligente, hogar inteligente, transporte inteligente y fábrica inteligente llevan al alumnado a conocer la tecnología agrícola, vivir la vida moderna, explorar la eficiencia del transporte y comprender la fabricación inteligente. La práctica manual despierta el pensamiento innovador y desarrolla la capacidad de resolver problemas, ayudando a afrontar el mundo inteligente.',
        },
      ],
      creativityItems: [
        {
          title: 'Reforzar la capacidad práctica',
          desc: 'Estos kits integran la educación STEMA (ciencia, tecnología, ingeniería, arte y matemáticas) y, mediante actividades prácticas y proyectos, mejoran de forma integral las capacidades prácticas y de resolución de problemas del alumnado.',
        },
        {
          title: 'Fomentar el pensamiento innovador',
          desc: 'Se anima al alumnado a diseñar y experimentar de forma creativa, desarrollando pensamiento innovador y creatividad. En proyectos en equipo, se refuerzan las habilidades de comunicación y colaboración.',
        },
        {
          title: 'Apoyo a la enseñanza del profesorado',
          desc: 'Se anima al alumnado a diseñar y experimentar de forma creativa, desarrollando pensamiento innovador y creatividad. En proyectos en equipo, se refuerzan las habilidades de comunicación y colaboración.',
        },
      ],
      projectItems: [
        { title: 'Ciencia' },
        { title: 'Tecnología' },
        { title: 'Programación' },
        { title: 'Arte' },
      ],
      bottomBannerText:
        'Los cursos, mediante la práctica manual y proyectos, refuerzan la capacidad práctica del alumnado y la resolución de problemas reales; fomentan el pensamiento innovador y la creatividad, animando al diseño y a la experimentación. Los proyectos en equipo mejoran la comunicación y la colaboración, y el contacto con tecnologías y herramientas de vanguardia ayuda a adaptarse a las necesidades de la sociedad futura.',
    },
    courses: {
      bannerTitle: 'Sistema de cursos',
      bannerDesc:
        'Cursos STEAM sistemáticos diseñados para distintas edades, integrando ciencia, tecnología, ingeniería, arte y matemáticas para formar talento innovador del futuro.',
      bannerAlt: 'Sistema de cursos',
      bottomBannerAlt: 'Presentación de cursos del sistema',
      sections: {
        kitsTitle: 'Kits de cursos',
        kitsDesc: 'La combinación perfecta de hardware y software',
        seriesTitle: 'Serie de cursos destacados',
      },
      courseTabs: [
        {
          name: 'Edad: 3–6',
          title: 'Sistema de exploración científica - Infantil (6 clases)',
          desc: 'A partir de fenómenos comunes de la vida cotidiana y con material didáctico científico, se profundiza en la exploración para comprender leyes y principios del desarrollo de los fenómenos.',
        },
        {
          name: 'Edad: 6–12',
          title: 'Sistema maker STEAM - Juvenil (3 clases)',
          desc: 'Desarrolla tu creatividad, aprende a usar equipos, practica con las manos y convierte ideas en proyectos.',
        },
        {
          name: 'Edad: 8–13',
          title: 'Sistema de cursos de corte láser (3 clases)',
          desc: 'Aprende a usar el equipo para cortar distintas piezas estructurales, ensamblarlas en estructuras tridimensionales y embellecerlas. Programación: comprender la lógica y los principios de las decisiones en programación.',
        },
        {
          name: 'Edad: 6–15',
          title: 'Sistema de cursos de inteligencia artificial (4 clases)',
          desc: 'Utiliza herramientas y equipos para diseñar y fabricar la apariencia de las creaciones, y mediante programación hazlas más inteligentes y fáciles de usar, resolviendo problemas de la vida cotidiana. Programación: comprender la lógica y los principios de las decisiones en programación; aprender la sintaxis de programación de Arduino.',
        },
      ],
      introItems: [
        {
          title: 'Alta orientación práctica',
          desc: 'El diseño del curso se centra en la práctica: el alumnado opera equipos como cortadoras láser, convirtiendo la teoría en habilidades operativas.',
        },
        {
          title: 'Desarrollo del pensamiento innovador',
          desc: 'El curso anima al alumnado a diseñar y crear de forma creativa, desarrollando pensamiento innovador y capacidad de resolución de problemas.',
        },
        {
          title: 'Aprendizaje impulsado por proyectos',
          desc: 'El curso adopta el aprendizaje orientado a proyectos: al completar tareas concretas, el alumnado aprende y domina conocimientos en la práctica.',
        },
        {
          title: 'Exploración de tecnologías de vanguardia',
          desc: 'Aprendizaje impulsado por proyectos: el alumnado practica durante tareas concretas y consolida conocimientos.',
        },
        {
          title: 'Enseñanza sistemática',
          desc: 'El curso avanza gradualmente de nivel inicial a intermedio y enseña de forma sistemática el corte láser, ayudando a construir una base sólida.',
        },
        {
          title: 'Equilibrio entre diversión y desafío',
          desc: 'El diseño del curso combina diversión y desafío, despertando el interés por aprender y el deseo de explorar.',
        },
      ],
      courseListRow1: [
        { name: 'Granja inteligente' },
        { name: 'Hogar inteligente' },
      ],
      courseListRow2: [
        { name: 'Transporte inteligente' },
        { name: 'Fábrica inteligente' },
      ],
      bottomBannerText:
        'Los cursos se caracterizan por práctica, pensamiento innovador e integración interdisciplinar; adoptan el aprendizaje impulsado por proyectos para que el alumnado domine tecnologías de vanguardia entre diversión y desafío. Junto con enseñanza sistemática, educación en seguridad y aprendizaje personalizado, se desarrollan habilidades manuales, espíritu de trabajo en equipo y capacidad de resolver problemas; se fomenta la presentación de logros y se refuerza el sentido de logro.',
    },
    kitsAccessories: {
      bannerTitle: 'Accesorios para kits',
      accessories: [
        { name: 'Tira LED RGB' },
        { name: 'Módulo de reloj DS1307' },
        { name: 'Sensor de temperatura y humedad DHT11' },
        { name: 'Sensor de detección de movimiento' },
        { name: 'Módulo de iluminación LED' },
        { name: 'Módulo de ventilador' },
        { name: 'Interruptor optoacoplador ranurado' },
        { name: 'Módulo de botón' },
        { name: 'Placa de control' },
        { name: 'Placa de expansión' },
        { name: 'Sensor de lluvia' },
        { name: 'Motor TT con placa adaptadora' },
        { name: 'Módulo sensor infrarrojo' },
        { name: 'Control remoto infrarrojo' },
        { name: 'Gas' },
        { name: 'Módulo de display de 4 dígitos' },
        { name: 'Teclado matricial' },
        { name: 'Sensor fotosensible' },
        { name: 'Módulo de semáforo' },
        { name: 'Zumbador' },
      ],
    },
    light530: {
      name: 'Light 530',
      bannerTitle:
        'Máquina inteligente de escritorio para corte y grabado láser',
      sections: {
        advantages: 'Nuestras ventajas',
        aiTitle: 'Llevar la educación con IA a la práctica',
        aiSubtitle:
          'IA+educación: impulso digital e integración de ideas innovadoras',
        carouselTitle: 'Posibilidades infinitas de grabado con luz',
        specsTitle: 'Especificaciones del producto',
      },
      bannerFeatures: [
        'Captura puntual / Calcar formas / Protección de seguridad',
        'Desarrollado específicamente para educación STEAM y makers',
      ],
      softwareSection: {
        title: 'Sistema de corte láser fácil de usar y potente',
        items: [
          'Permite configurar parámetros de proceso según el material, como: corte, grabado profundo, grabado superficial, escaneado, etc.',
          'Biblioteca abundante de plantillas y recursos para mejorar la eficiencia de diseño.',
          'La cámara admite captura puntual y ayuda al diseño, convirtiendo las ideas en realidad.',
        ],
      },
      advantages: [
        {
          tagTitle: 'Láser de alta calidad y alta precisión',
          desc: 'Por ejemplo, tubo láser de CO₂ importado de origen, con longitud de onda de 10640nm y potencia láser continua de 50W. El grosor máximo de corte alcanza 15mm (acrílico). Velocidad de trabajo de hasta 1000mm/s y precisión de repetición de 0.025mm. Garantiza precisión para cortar y grabar con rapidez y exactitud creaciones finas y creativas.',
        },
        {
          tagTitle: 'Sistema integrado de triple filtración de gases',
          desc: 'Diseño integrado de caja de ventilación con múltiples sistemas de filtración de humos: malla filtrante, carbón activo y capa UV de ozono. Es más limpio y respetuoso con el medio ambiente; además, facilita la colocación del equipo de forma más compacta, sin necesidad de comprar por separado una caja de filtración ni ocupar más espacio.',
        },
        {
          tagTitle: 'Protección de seguridad de máxima prioridad',
          desc: 'Supera las pruebas de seguridad de más alto nivel del laboratorio SGS y cuenta con certificación FDA: producto láser de clase I. Dispone de un diseño único de indicadores de seguridad y estado de trabajo que permite comprender de forma intuitiva y clara el estado de funcionamiento de la máquina.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        leftSpecs: [
          {
            label: 'Tipo de láser',
            value: 'Tubo láser de CO₂ de vidrio sellado',
          },
          { label: 'Recorrido de elevación del cabezal láser', value: '≤25mm' },
          { label: 'Grosor máximo de material', value: '≤22mm' },
          {
            label: 'Modo de enfoque',
            value: 'Enfoque automático, enfoque manual',
          },
          {
            label: 'Conectividad',
            value: 'Admite conexión USB, cable de red y WIFI',
          },
          { label: 'Sistemas operativos compatibles', value: 'Windows, iOS' },
          {
            label: 'Software de diseño compatible',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks, etc.',
          },
          {
            label: 'Formatos de archivo compatibles',
            value: 'JPG, DXF, AI, DST, PNG, BMP, TIF, SVG, etc.',
          },
          { label: 'Vida útil del láser', value: '≤9000 horas' },
          {
            label: 'Software (PC/móvil)',
            value: 'LightMaker (PC y móvil), Lightburn (PC)',
          },
          {
            label: 'Métodos de control',
            value: 'Pantalla táctil LCD de 5" / App móvil / Software PC',
          },
          { label: 'Ruido de funcionamiento', value: '≤60db' },
          {
            label: 'Transmisión',
            value:
              'Motor paso a paso de alta velocidad + guía lineal de alta precisión + correa síncrona',
          },
          {
            label: 'Protección de seguridad',
            value:
              'Interruptor de enclavamiento (se detiene al abrir la tapa), parada por impacto, botón de emergencia, llave de seguridad, indicador de estado, alarma de alta temperatura del depósito de agua',
          },
          { label: 'Sistema de alimentación', value: '230V/110VAC 50HZ/60HZ' },
          { label: 'Peso de la máquina', value: '≈70kg' },
        ],
        waterCoolingSpecs: [
          {
            label: 'Modo de refrigeración',
            value: 'Sistema de refrigeración por agua integrado (agua activa)',
          },
          {
            label: 'Voltaje de trabajo',
            value: '24V CC, refrigeración por aire + serpentín de aluminio',
          },
          { label: 'Capacidad del depósito', value: '3.2L' },
          { label: 'Altura máxima de bombeo', value: '5M' },
          {
            label: 'Caudal de agua',
            value:
              '1000L/H o enfriador láser CW3000 externo dedicado (opcional)',
          },
        ],
        airPumpSpecs: [
          { label: 'Caudal de aire', value: '50L/min' },
          { label: 'Ruido', value: '≤48dB' },
          { label: 'Presión de aire', value: '≥0.05Mpa' },
        ],
        exhaustSpecs: [
          { label: 'Potencia nominal', value: '62W' },
          { label: 'Caudal de aire', value: '280m³/H' },
          { label: 'Ruido', value: '≤50dB' },
          { label: 'Voltaje', value: 'AC 220V/110V' },
        ],
        groups: {
          waterCoolingTitle:
            'Parámetros del sistema de refrigeración por agua (integrado)',
          airPumpTitle: 'Parámetros de la bomba de aire (integrada)',
          airPumpValueOnly: 'CA 220V/110V 16W',
          exhaustTitle:
            'Parámetros del sistema de extracción (unidad externa integrada), extracción lateral inferior',
          filterTitle: 'Sistema de filtración',
          filterValue:
            'Algodón filtrante de carbón activo + ventilador silencioso + placa de carbón activo industrial',
        },
      },
    },
    lightbule530: {
      name: 'Light Blue 530',
      bannerTitle: 'Máquina inteligente de corte y grabado con láser azul',
      sections: {
        advantages: 'Nuestras ventajas',
        aiTitle: 'Llevar la educación con IA a la práctica',
        aiSubtitle:
          'IA+educación: impulso digital e integración de ideas innovadoras',
        carouselTitle: 'Posibilidades infinitas de grabado con luz',
        specsTitle: 'Especificaciones del producto',
      },
      bannerFeatures: [
        'Procesa múltiples materiales',
        'Crea con confianza, en cualquier momento y con facilidad',
      ],
      advantages: [
        {
          tagTitle: 'Huella compacta',
          desc: 'La grabadora láser azul tiene un diseño moderno, elegante y compacto, ideal para cualquier hogar, escuela o taller. La combinación precisa de cuerpo metálico y tapa acrílica permite ver claramente el proceso de trabajo del material.',
        },
        {
          tagTitle: 'Procesamiento cerrado, aislamiento para evitar lesiones',
          desc: 'La grabadora láser azul es totalmente cerrada: si se abre la tapa durante el trabajo, se pausa automáticamente. En caso de emergencia, un solo interruptor permite detener la máquina de inmediato. Ideal para uso doméstico y escolar.',
        },
        {
          tagTitle:
            'Procesamiento multimaterial, compatible con cientos de materiales',
          desc: 'Personaliza series de productos dinámicas con formas y estilos únicos. Añade accesorios para grabar materiales con más formas, como tazas y objetos cilíndricos, ideal para las necesidades de pequeños negocios.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {
          waterCoolingTitle: 'Sistema de refrigeración',
          airPumpTitle: 'Parámetros de la bomba de aire',
          airPumpValueOnly: '—',
          exhaustTitle: 'Sistema de extracción',
          filterTitle: 'Sistema de filtración',
          filterValue: '—',
        },
        left: [
          { key: 'laserType', label: 'Tipo de láser', value: 'Láser azul' },
          {
            key: 'laserPower',
            label: 'Potencia del láser',
            value: '20W / 40W',
          },
          {
            key: 'maxCutThickness',
            label: 'Grosor máximo de corte',
            value: '≤10mm',
          },
          {
            key: 'focusMode',
            label: 'Modo de enfoque',
            value: 'Enfoque manual',
          },
          { key: 'connection', label: 'Conectividad', value: 'Conexión USB' },
          {
            key: 'os',
            label: 'Sistemas operativos compatibles',
            value: 'Windows / Android / iOS',
          },
          {
            key: 'softwareOS',
            label: 'Software',
            value: 'LightBurn（PC）',
          },
          {
            key: 'laserLifetime',
            label: 'Vida útil del láser',
            value: '≥10000 horas',
          },
          {
            key: 'maxMaterialThickness',
            label: 'Grosor admitido de material',
            value: '15mm',
          },
          { key: 'noise', label: 'Ruido de funcionamiento', value: '≤60dB' },
          {
            key: 'engraveSpeed',
            label: 'Velocidad de grabado',
            value: '600mm/s',
          },
          {
            key: 'designSoftware',
            label: 'Software de diseño compatible',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks, etc.',
          },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          {
            key: 'maxSpeed',
            label: 'Velocidad máxima de trabajo',
            value: '1000mm/s',
          },
          {
            key: 'power',
            label: 'Sistema de alimentación',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          {
            key: 'workTable',
            label: 'Tamaño de la mesa de trabajo',
            value: '520 × 315mm',
          },
          {
            key: 'accuracy',
            label: 'Precisión de posicionamiento',
            value: '±0.01mm',
          },
          {
            key: 'repeatAccuracy',
            label: 'Precisión de repetición',
            value: '±0.005mm',
          },
          {
            key: 'powerRequirement',
            label: 'Requisitos de alimentación',
            value: 'AC 220V ±10%，50Hz',
          },
          {
            key: 'totalPower',
            label: 'Potencia total de la máquina',
            value: '300W',
          },
          {
            key: 'transmission',
            label: 'Transmisión',
            value:
              'Motor paso a paso de alta velocidad + guía lineal de alta precisión + correa síncrona',
          },
          {
            key: 'safety',
            label: 'Protección de seguridad',
            value:
              'Interruptor de enclavamiento (se detiene al abrir la tapa) + límite con eje elástico + botón de emergencia + llave de seguridad',
          },
          { key: 'weight', label: 'Peso de la máquina', value: '≈50kg' },
          {
            key: 'machineSize',
            label: 'Dimensiones de la máquina',
            value: '805 × 585 × 320mm',
          },
        ],
      },
    },
    lightm20: {
      name: 'Mark M20',
      bannerTitle: 'Marcadora láser de alta precisión',
      sections: {
        advantages: 'Nuestras ventajas',
        aiTitle: 'Llevar la educación con IA a la práctica',
        aiSubtitle:
          'IA+educación: impulso digital e integración de ideas innovadoras',
        carouselTitle: 'Marcado láser, personalización creativa',
        specsTitle: 'Especificaciones del producto',
      },
      bannerFeatures: [
        'Seguridad garantizada: doble interruptor de control y protección láser',
        'Alta precisión, alta velocidad y gran estabilidad en el grabado y marcado',
      ],
      advantages: [
        {
          tagTitle: 'Escenarios de aplicación diversos',
          desc: 'Este equipo es adecuado para múltiples sectores, como grabado de joyería, objetos personalizados e identificación de piezas, y cubre desde joyas y frascos de perfume hasta pequeños rótulos industriales.',
        },
        {
          tagTitle: 'Aplicación innovadora en educación',
          desc: 'El Mark M20 introduce precisión de nivel industrial en el ámbito educativo, convirtiéndose en un “asistente todoterreno” para la educación maker y de innovación, y ayuda al alumnado a desarrollar habilidades desde el marcado básico hasta proyectos complejos.',
        },
        {
          tagTitle: 'Compacta y moderna',
          desc: 'La marcadora láser Mark M20 tiene un diseño compacto y moderno, con huella reducida, bajo ruido y una gran ventana de visión, cumpliendo requisitos de alta durabilidad. Su estética elegante cumple normas de seguridad y es apta para instituciones educativas y entornos comerciales.',
        },
        {
          tagTitle: 'Marcado en segundos',
          desc: 'Incluso con la tipografía más pequeña, el Mark M20 puede completar un marcado preciso en cuestión de segundos. Esta velocidad incomparable, combinada con el flujo de trabajo simplificado y eficiente de nuestro software LightMaker, garantiza un aumento notable de la productividad. ',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {},
        left: [
          { key: 'laserType', label: 'Tipo de láser', value: 'Láser de fibra' },
          {
            key: 'laserPower',
            label: 'Potencia del láser',
            value: '20W / 30W / 50W',
          },
          {
            key: 'markArea',
            label: 'Área de marcado',
            value:
              'Estándar 110×110mm（se puede ampliar cambiando diferentes lentes de campo, como 175×175mm, etc.）',
          },
          {
            key: 'maxHeight',
            label: 'Altura máxima de trabajo',
            value: '≤130mm',
          },
          { key: 'connection', label: 'Conectividad', value: 'Ethernet' },
          {
            key: 'os',
            label: 'Sistemas operativos compatibles',
            value: 'Windows / iOS / Android',
          },
          {
            key: 'power',
            label: 'Sistema de alimentación',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          {
            key: 'safety',
            label: 'Protección de seguridad',
            value:
              'Interruptor de enclavamiento (se detiene al abrir la tapa)、límite con eje elástico、botón de emergencia、llave de seguridad',
          },
          { key: 'software', label: 'Software compatible', value: 'Mantimark' },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          {
            key: 'transmission',
            label: 'Transmisión',
            value:
              'Elevación mediante husillo eléctrico de alta precisión del cabezal de marcado',
          },
          {
            key: 'fileFormat',
            label: 'Formatos de archivo compatibles',
            value: 'SVG / DXF / JPG / JPEG / PNG / BMP / TIF',
          },
          {
            key: 'spotSize',
            label: 'Diámetro del punto focal',
            value: '≤20μm',
          },
        ],
      },
    },
    light640: {
      name: 'Light 640',
      bannerTitle:
        'Máquina inteligente de escritorio para corte y grabado láser',
      sections: {
        advantages: 'Nuestras ventajas',
        aiTitle: 'Llevar la educación con IA a la práctica',
        aiSubtitle:
          'IA+educación: impulso digital e integración de ideas innovadoras',
        carouselTitle: 'Corte creativo, empieza aquí',
        specsTitle: 'Especificaciones del producto',
      },
      bannerFeatures: [
        'Rápida / Puerta trasera abierta / Enfoque automático eficiente',
        'Cortadora y grabadora láser todo en uno',
      ],
      models: [
        { id: 'light640', name: 'Light 640' },
        { id: 'light960', name: 'Light 960' },
        { id: 'light1390', name: 'Light 1390' },
        { id: 'light1610', name: 'Light 1610' },
      ],
      advantages: [
        {
          tagTitle: 'Área de trabajo',
          desc: 'Resultados excelentes de corte y grabado, varios modelos y configuraciones de potencia láser para satisfacer distintas necesidades de aplicación\nTipo de láser：CO2 CC\nPotencia del láser：60W-130W\nLight640（600*400mm）\nLight960（900*600mm）\nLight1390（1300*900mm）\nLight1610（1600*1000mm）',
        },
        {
          tagTitle:
            'Enfoque automático eficiente + posicionamiento por punto rojo',
          desc: 'El enfoque automático permite enfocar y posicionar de forma rápida y precisa antes de cortar o grabar. Con el haz de posicionamiento por punto rojo, se puede ver la posición de trabajo en tiempo real. Así, se ahorra tiempo de corte y grabado y se obtiene un mejor resultado.',
        },
        {
          tagTitle: 'Diseño de puerta trasera abierta',
          desc: 'El diseño de puerta trasera abierta permite colocar materiales de corte y grabado de longitud ilimitada. Las láminas de 600mm×∞ hacen el trabajo más cómodo y con menos restricciones.',
        },
      ],
      advantagesByModel: {
        light960: [
          {
            tagTitle: 'Resultados excelentes de corte y grabado',
            desc: 'La cortadora láser incorpora una plataforma de corte de alta precisión. El procesamiento de materiales como madera y acrílico alcanza estándares y eficiencia de nivel industrial, permitiendo la producción en serie de artesanías láser y elevando la productividad y el valor de marca.',
          },
          {
            tagTitle: 'Tubo láser de alta calidad y componentes de precisión',
            desc: 'Una línea de productos diversificada permite elegir distintos tipos de láser y niveles de procesamiento según las necesidades, satisfaciendo múltiples requisitos de producción y ampliando las aplicaciones para madera, vidrio, acrílico y otros materiales.',
          },
          {
            tagTitle:
              'Pruebas rigurosas de calidad óptica, garantía de calidad',
            desc: 'Las pruebas estrictas en línea de producción, el control preciso del recorrido óptico y más de 5 pruebas de corte y grabado garantizan un tubo láser de CO2 de primera calidad con salida estable y uniforme. Gracias a la excelente estabilidad de potencia y al fino punto láser, se logra un grabado uniforme, incluso con detalles complejos.',
          },
        ],
        light1390: [
          {
            tagTitle: 'Resultados excelentes de corte y grabado',
            desc: 'La cortadora láser incorpora una plataforma de corte de alta precisión. El procesamiento de materiales como madera y acrílico alcanza estándares y eficiencia de nivel industrial, permitiendo la producción en serie de artesanías láser y elevando la productividad y el valor de marca.',
          },
          {
            tagTitle: 'Tubo láser de alta calidad y componentes de precisión',
            desc: 'Una línea de productos diversificada permite elegir distintos tipos de láser y niveles de procesamiento según las necesidades, satisfaciendo múltiples requisitos de producción y ampliando las aplicaciones para madera, vidrio, acrílico y otros materiales.',
          },
          {
            tagTitle:
              'Pruebas rigurosas de calidad óptica, garantía de calidad',
            desc: 'Las pruebas estrictas en línea de producción, el control preciso del recorrido óptico y más de 5 pruebas de corte y grabado garantizan un tubo láser de CO2 de primera calidad con salida estable y uniforme. Gracias a la excelente estabilidad de potencia y al fino punto láser, se logra un grabado uniforme, incluso con detalles complejos.',
          },
        ],
        light1610: [
          {
            tagTitle: 'Funciones de seguridad completas y avanzadas',
            desc: '1. Parada de emergencia\n2. Luz de alarma\n3. Interruptor impermeable\n4. Cable de puesta a tierra\n5. El detector térmico integrado activa la alarma automáticamente ante actividad anómala de la máquina\n6. Protección de cierre de tapa\n7. Ventana de protección duradera de vidrio templado',
          },
          {
            tagTitle: 'Duradera y de calidad excepcional',
            desc: '1. Ideal para proyectos unitarios o producción a gran escala。\n2. Amplia gama de áreas de trabajo, desde 600 x 400MM hasta 1600 x 1000MM。\n3. Velocidad de grabado incomparable。\n4. Diseño de expertos del sector。\n5. Ideal para aplicaciones personalizadas, educativas e industriales。',
          },
          {
            tagTitle: 'Optimiza la producción con supervisión inteligente',
            desc: 'Diseñada para proteger los componentes más valiosos del equipo (ejes, cabezal láser, elementos ópticos y lentes) del polvo y la suciedad. Incluso con uso intensivo, garantiza años de funcionamiento sin fallos.',
          },
        ],
      },
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      carouselByModel: {
        light640: {
          title: '¿Qué se puede hacer con Light 640?',
          items: [
            {
              title: 'Light 640 - Proyecto 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 640 - Proyecto 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 640 - Proyecto 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 640 - Proyecto 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 640 - Proyecto 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 640 - Proyecto 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 640 - Proyecto 7',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 640 - Proyecto 8',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light960: {
          title: '¿Qué se puede hacer con Light 960?',
          items: [
            {
              title: 'Light 960 - Proyecto 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 960 - Proyecto 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 960 - Proyecto 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 960 - Proyecto 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 960 - Proyecto 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 960 - Proyecto 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 960 - Proyecto 7',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 960 - Proyecto 8',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1390: {
          title: '¿Qué se puede hacer con Light 1390?',
          items: [
            {
              title: 'Light 1390 - Proyecto 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 1390 - Proyecto 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 1390 - Proyecto 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 1390 - Proyecto 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 1390 - Proyecto 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 1390 - Proyecto 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 1390 - Proyecto 7',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 1390 - Proyecto 8',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1610: {
          title: '¿Qué se puede hacer con Light 1610?',
          items: [
            {
              title: 'Light 1610 - Proyecto 1',
              image: require('@/assets/product/1610-1.png'),
            },
            {
              title: 'Light 1610 - Proyecto 2',
              image: require('@/assets/product/1610-2.png'),
            },
            {
              title: 'Light 1610 - Proyecto 3',
              image: require('@/assets/product/1610-3.png'),
            },
            {
              title: 'Light 1610 - Proyecto 4',
              image: require('@/assets/product/1610-4.png'),
            },
            {
              title: 'Light 1610 - Proyecto 5',
              image: require('@/assets/product/1610-5.png'),
            },
            {
              title: 'Light 1610 - Proyecto 6',
              image: require('@/assets/product/1610-6.png'),
            },
            {
              title: 'Light 1610 - Proyecto 7',
              image: require('@/assets/product/1610-7.png'),
            },
            {
              title: 'Light 1610 - Proyecto 8',
              image: require('@/assets/product/1610-8.png'),
            },
          ],
        },
      },
      specs: {
        groups: {
          waterCoolingTitle: 'Sistema de refrigeración',

          exhaustTitle: 'Sistema de extracción',
        },
        left: [
          { key: 'model', label: 'Modelo del equipo', value: 'Light 640' },
          { key: 'workArea', label: 'Área de trabajo', value: '600mm × 400mm' },
          {
            key: 'laserType',
            label: 'Tipo de láser',
            value: 'Tubo láser de CO₂ de vidrio sellado',
          },
          {
            key: 'laserPower',
            label: 'Potencia del láser',
            value: '60W / 80W / 100W',
          },
          {
            key: 'zAxis',
            label: 'Altura del eje Z',
            value: '135mm（5.3 pulgadas）',
          },
          {
            key: 'tableSize',
            label: 'Tamaño de la mesa',
            value: '700 × 530mm（27.6″ × 20.9″）',
          },
          {
            key: 'maxMaterialFrontBack',
            label:
              'Tamaño máximo del material（puertas delantera y trasera cerradas）',
            value: '700 × 530 × 170mm（27.6″ × 20.9″ × 6.7″）',
          },
          {
            key: 'maxMaterialOpen',
            label: 'Tamaño máximo del material（puerta trasera abierta）',
            value: '700 × ∞ × 20mm（27.6″ × ∞ × 0.8″）',
          },
          {
            key: 'machineSize',
            label: 'Dimensiones de la máquina（ancho × largo × alto）',
            value: '1450 × 950 × 1180mm（57.1″ × 37.4″ × 46.5″）',
          },
          {
            key: 'weight',
            label: 'Peso de la máquina',
            value: '300kg（660 lb）',
          },
          {
            key: 'maxSpeed',
            label: 'Velocidad máxima de trabajo',
            value: '1000mm/s',
          },
          {
            key: 'accuracy',
            label: 'Precisión de posicionamiento',
            value: '0.01mm – 0.05mm',
          },
          {
            key: 'focusMode',
            label: 'Modo de enfoque',
            value: 'Enfoque automático / Enfoque manual',
          },
          {
            key: 'resume',
            label: 'Reanudar tras un corte de energía',
            value: 'Compatible',
          },
          {
            key: 'transmission',
            label: 'Transmisión',
            value:
              'Motor paso a paso de alta velocidad + motor de lazo cerrado de alta precisión',
          },
          {
            key: 'connection',
            label: 'Conectividad',
            value: 'LAN（Ethernet） / USB / WiFi',
          },
        ],
        right: [
          {
            key: 'software',
            label: 'Software',
            value: 'Good-Laser LightMaker（compatible con LightBurn）',
          },
          {
            key: 'process',
            label: 'Procesos',
            value:
              'Dibujo lineal、corte、grabado profundo、grabado superficial',
          },
          {
            key: 'fileFormats',
            label: 'Formatos de archivo compatibles',
            value:
              'Mapa de bits：JPG / PNG / BMP；Vector：LPC / DXF / PLT / SVG',
          },
          {
            key: 'frequency',
            label: 'Frecuencia',
            value: '50 / 60Hz',
          },
          {
            key: 'phase',
            label: 'Fase',
            value: 'Monofásico',
          },
          {
            key: 'current',
            label: 'Corriente a plena carga',
            value: '6A',
          },
          {
            key: 'voltage',
            label: 'Voltaje',
            value: '230V CA',
          },
          {
            key: 'totalPower',
            label: 'Potencia total',
            value: '≤ 1.5kW',
          },
          {
            key: 'materials',
            label: 'Materiales compatibles',
            value:
              'Madera, acrílico, cuero, tela, plástico, cartón, goma, lámina bicolor, mármol, vidrio, aluminio anodizado y otros materiales no metálicos',
          },
          {
            key: 'safety',
            label: 'Normas de seguridad',
            value:
              'Cumple las normas de seguridad CE de la UE e incluye protección al abrir la cabina, sistema de protección de refrigeración, sistema automático de alarma por control de temperatura, sistema de protección de fugas eléctricas, sistema de parada de emergencia, sistema óptico, sistema de observación con vidrio templado, indicador de estado de trabajo, etc.',
          },
        ],
        water: [
          {
            key: 'coolingMode',
            label: 'Modo de refrigeración',
            value: 'Refrigeración por agua',
          },
        ],

        exhaust: [
          {
            key: 'exhaustDiameter',
            label: 'Diámetro de salida de extracción',
            value: '150mm',
          },
        ],
      },
      modelSpecOverrides: {
        light960: {
          model: 'Light 960',
          workArea: '900mm × 600mm',
          laserType: 'Tubo láser de CO₂ de vidrio sellado',
          laserPower: '80W / 100W / 120W',
          zAxis: '135mm（5.3 pulgadas）',
          tableSize: '1000 × 730mm（39.4″ × 28.7″）',
          maxMaterialFrontBack: '1000 × 730 × 170mm（39.4″ × 28.7″ × 9.0″）',
          maxMaterialOpen: '1000 × ∞ × 20mm（39.4″ × ∞ × 0.8″）',
          machineSize: '1500 × 1200 × 1180mm（59.1″ × 47.5″ × 45.5″）',
          weight: '410kg（902 lb）',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Enfoque automático / Enfoque manual',
          resume: 'Compatible',
          transmission:
            'Motor paso a paso de alta velocidad + motor de lazo cerrado de alta precisión',
          connection: 'LAN（Ethernet） / USB / WiFi',
          software: 'Good-Laser LightMaker（compatible con LightBurn）',
          process:
            'Dibujo lineal、corte、grabado profundo、grabado superficial',
          fileFormats:
            'Mapa de bits：JPG / PNG / BMP；Vector：LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Monofásico',
          current: '6A',
          voltage: '230V CA',
          totalPower: '≤ 1.5kW',
          materials:
            'Madera, acrílico, cuero, tela, plástico, cartón, goma, lámina bicolor, mármol, vidrio, aluminio anodizado y otros materiales no metálicos',
          safety:
            'Cumple las normas de seguridad CE de la UE e incluye protección al abrir la cabina, sistema de protección de refrigeración por agua, sistema automático de alarma por control de temperatura, sistema de protección de fugas eléctricas, sistema de parada de emergencia, sistema óptico, sistema de observación con vidrio templado, indicador de estado de trabajo, etc.',
          coolingMode: 'Refrigeración por agua',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1390: {
          model: 'Light 1390',
          workArea: '1300mm × 900mm',
          laserType: 'Tubo láser de CO₂ de vidrio sellado',
          laserPower: '100W / 130W / 150W',
          zAxis: '135mm（5.3 pulgadas）',
          tableSize: '1370 × 900mm（53.4″ × 35.5″）',
          maxMaterialFrontBack: '1370x900x135mm(53.4"x35.5"x5.4")',
          maxMaterialOpen: '1370 × ∞ × 30mm（54.0″ × ∞ × 1.2″）',
          machineSize: '1860 × 1450 × 1200mm（73.3″ × 57.1″ × 46.5″）',
          weight: '500kg（1100 lb）',
          maxSpeed: '600mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Enfoque automático / Enfoque manual',
          resume: 'Compatible',
          transmission:
            'Motor paso a paso de alta velocidad + motor de lazo cerrado de alta precisión',
          connection: 'LAN（Ethernet） / USB / WiFi',
          software: 'Good-Laser LightMaker（compatible con LightBurn）',
          process:
            'Dibujo lineal、corte、grabado profundo、grabado superficial',
          fileFormats:
            'Mapa de bits：JPG / PNG / BMP；Vector：LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Monofásico',
          current: '6A',
          voltage: '230V CA',
          totalPower: '≤ 1.5kW',
          materials:
            'Madera, acrílico, cuero, tela, plástico, cartón, goma, lámina bicolor, mármol, vidrio, aluminio anodizado y otros materiales no metálicos',
          safety:
            'Cumple las normas de seguridad CE de la UE e incluye protección al abrir la cabina, sistema de protección de refrigeración por agua, sistema automático de alarma por control de temperatura, sistema de protección de fugas eléctricas, sistema de parada de emergencia, sistema óptico, sistema de observación con vidrio templado, indicador de estado de trabajo, etc.',
          coolingMode: 'Refrigeración por agua',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1610: {
          model: 'Light 1610',
          workArea: '1600mm × 1000mm',
          laserType: 'Tubo láser de CO₂ de vidrio sellado',
          laserPower: '110W / 130W / 150W',
          zAxis: '135mm（5.3 pulgadas）',
          tableSize: '1700 × 1130mm（66.9″ × 44.5″）',
          maxMaterialFrontBack: '1700 × 1130 × 170mm',
          maxMaterialOpen: '1700 × ∞ × 20mm',
          machineSize: '2200 × 1500 × 1180mm',
          weight: '590kg（1298 lb）',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Enfoque automático / Enfoque manual',
          resume: 'Compatible',
          transmission:
            'Motor paso a paso de alta velocidad + motor de lazo cerrado de alta precisión',
          connection: 'LAN（Ethernet） / USB / WiFi',
          software: 'Good-Laser LightMaker（compatible con LightBurn）',
          process:
            'Dibujo lineal、corte、grabado profundo、grabado superficial',
          fileFormats:
            'Mapa de bits：JPG / PNG / BMP；Vector：LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Monofásico',
          current: '6A',
          voltage: '230V CA',
          totalPower: '≤ 1.5kW',
          materials:
            'Madera, acrílico, cuero, tela, plástico, cartón, goma, lámina bicolor, mármol, vidrio, aluminio anodizado y otros materiales no metálicos',
          safety:
            'Cumple plenamente las normas de seguridad CE de la UE e incluye protección al abrir la tapa, protección de refrigeración por agua, alarma de temperatura, protección contra fugas, parada de emergencia y sistema de interbloqueo láser',
          coolingMode: 'Refrigeración por agua',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
      },
    },
  },

  footer: {
    subscribe: {
      placeholder: 'Tu dirección de correo electrónico',
      button: 'Suscribirse',
    },
    social: {
      tiktok: 'TikTok',
      weibo: 'WeChat Channels',
      wechat: 'WeChat',
      redbook: 'Xiaohongshu',
    },
    companyDesc:
      'Nos centramos en la educación de creatividad tecnológica para niños y jóvenes de 3 a 16 años. Creamos espacios de innovación educativa y desarrollamos de forma independiente productos y cursos, abarcando módulos como software de diseño, grabado láser y programación.',
    navColumns: [
      {
        title: 'Productos',
        items: [
          { label: 'Equipos', to: '/product/light530' },
          { label: 'Kits', to: '/product/kits' },
          { label: 'Cursos', to: '/product/courses' },
        ],
      },
      {
        title: 'Software',
        items: [
          {
            label: 'Plataforma en la nube Zhongze Education',
            to: '/software/cloud-platform',
          },
          {
            label: 'Plataforma de aprendizaje Zhongze Education',
            to: '/software/learning-platform',
          },
          { label: 'Light Maker', to: '/software/laser-software' },
        ],
      },
      {
        title: 'Servicios educativos',
        items: [
          { label: 'Solución educativa de IA', to: '/edu-services' },
          {
            label: 'Maker educativo - Primaria y Secundaria',
            to: '/edu-services/maker-k12',
          },
          {
            label: 'Modelos arquitectónicos - Formación profesional',
            to: '/edu-services/architectural-vocational',
          },
          {
            label: 'Diseño cultural y creativo - FP superior',
            to: '/edu-services/cultural-higher-vocational',
          },
          {
            label: 'Artes y artesanías - Universidades',
            to: '/edu-services/arts-university',
          },
          { label: 'Espacio maker', to: '/edu-services' },
        ],
      },
      {
        title: 'Servicio y soporte',
        items: [
          { label: 'Centro de descargas', to: '/support/download' },
          { label: 'Servicio posventa', to: '/support/after-sales' },
        ],
      },
      {
        title: 'Cooperación educativa',
        items: [
          { label: 'Cooperación educativa', to: '/edu-services/cooperation' },
        ],
      },
      {
        title: 'Sobre nosotros',
        items: [
          { label: 'Sobre nosotros', to: '/about' },
          { label: 'Noticias', to: '/about/news' },
        ],
      },
    ],
    contact: {
      phone: 'Línea de ventas：18379276683',
      email: 'Correo：sam@zz-steam.com',
      address:
        'Dirección：Torre A, Edificio Huashengda, Bagua 4th Rd, Futian, Shenzhen',
    },
    qrDesc: 'Saber más',
  },

  globalContactForm: {
    title: 'Contáctanos',
    subtitle:
      'Rellena el siguiente formulario y nos pondremos en contacto lo antes posible',
    fields: {
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      company: 'Empresa',
      message: 'Mensaje',
    },
    placeholders: {
      name: 'Introduce tu nombre',
      email: 'Introduce tu correo electrónico',
      phone: 'Introduce tu teléfono',
      company: 'Introduce el nombre de tu empresa',
      message: 'Introduce tu mensaje',
    },
    submitting: 'Enviando...',
    submit: 'Enviar',
    visual: {
      title: 'Esperamos colaborar contigo',
      description:
        'Ofrecemos servicios y soporte profesionales; si tienes cualquier duda, contáctanos en cualquier momento.',
    },
    contact: {
      phone: 'Teléfono de contacto',
      email: 'Correo de contacto',
    },
    validation: {
      name: 'Introduce tu nombre',
      email: 'Introduce tu correo electrónico',
      emailFormat: 'Introduce un correo electrónico válido',
      phone: 'Introduce tu número de teléfono',
      phoneFormat: 'Introduce un número de teléfono válido',
      message: 'Introduce tu mensaje',
    },
    success:
      '¡Enviado correctamente! Nos pondremos en contacto lo antes posible.',
    networkError: 'Error al enviar, inténtalo de nuevo más tarde.',
  },
};
